import {Loader2} from 'lucide-react';

export const Icons = {
  spinner: Loader2,
};